export const environment = {
  production: true,
  api: 'https://hatchit.hatch-pd.com/api/',
};
